/**
 *
 * Asynchronously loads the component for TeamsList
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
